import React from 'preact';
import Router from 'preact-router';
import AsyncRoute from 'preact-async-route';

// import Redirect from './Redirect';
import Header from './Header';
import Footer from './Footer';
import About from './page/About';
import NotFound from './page/NotFound';

// import Blog from './page/Blog';

import '../scss/style.scss';

/**
 * Entry point. The first file loaded into index.html
 */
export default props => (
  <div>
    <Header />
    <Router>
      {/* <Redirect path="/" to="/about" /> */}
      <About path="/" />
      <About path="/about" />
      {/* split bundles */}
      <AsyncRoute
        path="/skills"
        getComponent={() =>
          System.import('./page/Skills').then(module => module.default)
        }
      />
      <AsyncRoute
        path="/likes"
        getComponent={() =>
          System.import('./page/Likes').then(module => module.default)
        }
      />
      <AsyncRoute
        path="/blog"
        getComponent={() =>
          System.import('./page/Blogs').then(module => module.default)
        }
      />
      <AsyncRoute
        path="/blog20171230"
        getComponent={() =>
          System.import('../blog/2017/1230').then(module => module.default)
        }
      />
      <AsyncRoute
        path="/blog20171204"
        getComponent={() =>
          System.import('../blog/2017/1204').then(module => module.default)
        }
      />
      <AsyncRoute
        path="/contact"
        getComponent={() =>
          System.import('./page/Contact').then(module => module.default)
        }
      />
      <NotFound default />
    </Router>
    <Footer />
  </div>
);

const userAgent = navigator.userAgent.toLowerCase();
if (userAgent.indexOf('chrome') > -1 || userAgent.indexOf('firefox') > -1) {
  console.log(
    '%c  %c  %c Well, hello there! %c  %c  ',
    'background-color: #dba8e6; font-size:12px;',
    'background-color: #d27be3; font-size:14px;',
    'background-color: #882299; color:white; font-size:16px;',
    'background-color: #d27be3; font-size:14px;',
    'background-color: #dba8e6; font-size:12px;'
  );
} else {
  console.log('Well, hello there!');
}

console.log(`
            (⌒)(⌒)                                                  
            Ｙ ･ ･ |                                                     
            |  >＿ノ                                                     
            |  |       _____            _____   _                 _     
      ____  |  |      |   __|___ ___   |   __|_| |_ _ _ ___ ___ _| |___ 
     /         |      |  |  | -_|   |  |   __| . | | | | .'|  _| . |_ -|
    |  //| ||| |      |_____|___|_|_|  |_____|___|_____|__,|_| |___|___|
    |_|| | |||_|                                                        
`);
console.log(`
Sourcemaps are included so you can take a look at what I did.
I strived for a simple and light weight site relying on Preact.js.
I’d love to hear what you think! http://${window.location.host}/contact
`);



// WEBPACK FOOTER //
// ./client/components/App.jsx